import React from "react";
import { Box, Card, Typography } from "@mui/material";
import PretPoints from "./EarningPretPoints";
import { useAppTheme } from "@/utils/theme";

interface EarningHistoryCardProps {
  title: string;
  description: string;
  points: number;
  date: string;
}

const EarningHistoryCard: React.FC<EarningHistoryCardProps> = ({
  title,
  description,
  points,
  date,
}) => {
  const theme = useAppTheme();

  return (
    <Card
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 16px",
        bgcolor: theme.palette.surface.light2,
        borderRadius: 2,
      }}
    >
      <Box display="flex" alignItems="center">
        <PretPoints points={points} />
        <Box className="ml-4 flex flex-col">
          <Typography variant="subtitle1" fontWeight="bold">
            {title}
          </Typography>
          <Typography
            variant="labelSmall"
            style={{ color: theme.palette.textMain.dark2 }}
          >
            {description}
          </Typography>
          <Typography
            style={{ color: theme.palette.textMain.dark2 }}
            variant="labelSmall"
          >
            {date}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default EarningHistoryCard;
